import axios from 'axios';
import 'mapbox-gl/dist/mapbox-gl.css';
import {createRoot} from 'react-dom/client';
import {AxiosInterceptor} from './api/axios.config';
import App from './App';
import './index.scss';
import './integrations/fullstory.service';
import {initSentry} from './integrations/sentry-init';

import reportWebVitals from './reportWebVitals';

// Trigger mainBundleLoaded event when the main bundle and CSS are loaded in order to hide the inline progress bar in the index.html file.
// Wait for CSS to load by checking if stylesheets are loaded
function triggerMainBundleLoaded() {
  // Check if all stylesheets are loaded
  const stylesheets = Array.from(document.styleSheets);
  const allStylesLoaded = stylesheets.every((sheet) => {
    try {
      // Try to access rules to check if stylesheet is loaded
      return sheet.rules || sheet.cssRules;
    } catch (e) {
      // Cross-origin stylesheets might throw, but that's okay
      return true;
    }
  });

  if (allStylesLoaded) {
    window.dispatchEvent(new CustomEvent('mainBundleLoaded'));
  } else {
    // If not all styles are loaded, wait a bit and try again
    setTimeout(triggerMainBundleLoaded, 100);
  }
}

// Start checking for CSS load after a short delay to allow CSS to start loading
setTimeout(triggerMainBundleLoaded, 50);

axios.defaults.baseURL = import.meta.env.VITE_API_URL;
AxiosInterceptor();

initSentry();

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
} else {
  console.error('App root element not found on index.tsx');
}

reportWebVitals();
